import type { ProductsFeatureConfig } from '@shared/products-feature-configs';

export const products: Partial<ProductsFeatureConfig> = {
    flagAndFeatureDrivenSelfServicing: true,
    fieldsWithGAPIPriority: ['balance', 'disposable', 'overdraft', 'nextRateAmount'],
};
